<template>
  <div class="menu-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'outlet_out_of_stock',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.menu_control')}}</router-link>
                  / {{$t('store.menu_out_of_stock_editing')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!-- Size Out of Stock -->
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.menu_out_of_stock_editing')}}
              </strong>
            </div>

            <b-row>
              <b-col xl="12" class="mb-2"><small class="pull-right text-grey">{{ $t('note_change_page_or_filter') }}</small></b-col>
              <b-col xl="6" class="mb-3">
                <div class="pull-left mr-3">
                  <label>{{$t('store.product_type')}}</label>
                  <b-form-radio-group
                    buttons
                    v-model="mode"
                    :options="options[$session.get('lang')]"
                    @input="changeMode"
                    name="radioBtnOutline" />
                </div>
                <div class="pull-left mr-3">
                  <b-input-group v-bind:prepend="$t('store.active')">
                    <b-form-select v-model="filter.active" v-bind:value="filter.active" :options="status[$session.get('lang')]" v-bind:placeholder="$t('store.active')">
                    </b-form-select>
                  </b-input-group>
                </div>
                <div class="pull-left mr-3" v-if="mode == 'menu'">
                  <b-input-group v-bind:prepend="$t('store.category')">
                    <b-form-select v-model="filter.category" v-bind:value="filter.category" :options="categories[$session.get('lang')]" v-bind:placeholder="$t('store.category')">
                    </b-form-select>
                  </b-input-group>
                </div>
              </b-col>
              <b-col xl="6" class="mb-3">
                <b-input-group>
                  <select-dropdown v-bind:options="filter.options"  v-bind:selected="filter.selected" position="prepend" v-model="field" v-bind:all="false" prefix="menu">
                  </select-dropdown>
                  <input type="text" class="form-control" v-model="key" v-on:keydown.enter="refreshData" style="min-width: 300px"/>                  
                  <div class="input-group-append">
                    <b-input-group-append>
                      <b-btn @click="refreshData">
                        <i class="fa fa-search" ></i> {{$t('common.search')}}
                      </b-btn>
                    </b-input-group-append>
                  </div>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <div class="rectangle-9-copy">
                  <div class="table-responsive">
                    <table class="table table-sm header-pointer">
                      <thead class="table-thead">
                      <tr>
                        <th scope="col" class="thead-th" v-for="item in dataTable.fields" :key="item.id">
                          <div v-if="! (mode == 'combo' && (item.name == 'firsts' || item.name == 'category_id'))">
                            <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                            <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                            <span v-if="item.name != '#'">{{$t('store.'+item.name)}}</span>
                          </div>
                        </th>
                        <th v-if="isShowReason()" scope="col" class="thead-th col-200w">
                          <span> {{$t('store.reason')}} </span>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 1">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="(item, index) in dataTable.items" :key="index">
                        <td scope="row" v-for="field in dataTable.fields" :key="field.id">
                          <div v-if="!((field.name == 'firsts' || field.name == 'category_id') && mode == 'combo')">
                            <span v-if="field.type && field.type == 'checkbox'">
                              <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0" @change="() => chooseMenu(item.value, item)"></b-form-checkbox>
                            </span>
                            <span v-else-if="field.name == 'name' && mode == 'combo'" >
                              {{item[field.name][$session.get('lang') || 'en']}}
                            </span>
                            <span v-else-if="field.render != null" v-html="field.render(item[(field.name=='code' ? 'sku' : field.name)], item)"></span>
                            <span v-else-if="field.render == null">
                              {{item[field.name[$session.get('lang') || 'en']]}}
                            </span>
                            <div v-if="field.name == 'firsts' && mode == 'menu'">
                              <div class="row first-layers mb-3" v-for="(first, i) in getValueFromAttr(item, 'first_layers', [])" :key="item.id + i">
                                <div class="col-sm-4">
                                  <b-form-checkbox class="checkbox-warning clearfix" v-model="first.value" :value="1" :unchecked-value="0" @change="() => chooseMenu(first.value, item, first)" :disabled="checkPermission($auth.user(), 'rgm-role-editable')">
                                    <span>{{first.name[$session.get('lang') || 'en']}}</span>
                                  </b-form-checkbox>
                                </div>
                                <div class="col-sm-8">
                                  <div class="clearfix" v-for="(second, j) in getValueFromAttr(first, 'second_layers', [])"  :key="second.id + (i * j + j)">
                                    <b-form-checkbox class="checkbox-warning" v-model="second.value" value="1" unchecked-value="0" @change="() => chooseMenu(second.value, item, first, second)" :disabled="checkPermission($auth.user(), 'rgm-role-editable')">
                                      <span >{{second.name[$session.get('lang') || 'en']}}</span>
                                    </b-form-checkbox>
                                  </div>
                                </div>
                                <hr>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td v-if="isShowReason()" :class="{ 'combobox-require': !item.reason_uuid }">
                          <b-form-select v-if="item.value == 1" v-model="item.reason_uuid" :options="reasonOptions[$session.get('lang') || 'en']" @change="enableSave = true">
                          </b-form-select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
              </b-col>
              <b-col col lg="1">
                <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3" />
              </b-col>
            </b-row>
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="() => $router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save" v-if="checkPermission($auth.user(),'post.v1.product-menu-be.menu-outlets')">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" :disabled="!enableSave" @click="pushMenuOutOfStock"> {{$t('common.save')}}
                </button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'

  export default {
    name: 'OutletMenuOutOfStock',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      Tables,
      cSwitch,
      vSelect,
      Multiselect,
      SelectDropdown
    },
    data: function () {
      return {
        languages: this.$store.getters.languages,
        outletConfig: this.$store.getters.config.gms.outlet,
        outletCode: '',
        key: null,
        field: null,
        status: [],
        categories: [],
        mode: 'menu',
        options: {},
        selectedItems: [],
        dataTable: {
          items: [],
          fields: [{
            name: '#',
            type: 'checkbox',
            filter: false,
            sort: false,
            render: (data, row) => {
              this.enableSave = true
              return '<b-form-checkbox id="checkbox1" class="checkbox-warning" value="1" unchecked-value="0"></b-form-checkbox>'
            }
          },
            {
              name: 'image',
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return '<img src="' + data.desktop_thumbnail + '" width="100" height="100">'
              }
            },
            {
              name: 'category_id',
              filter: false,
              sort: false,
              render: (data, row) => {
                if (row.category == null || row.category.name == null) {
                  return ''
                }
                return row.category.name[this.$session.get('lang')]
              }
            },
            {
              name: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'firsts',
              filter: false,
              sort: false
            },
          ],
          sort: {
            field: null,
            type: 'asc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        filter: {
          options: [
            {
              name: 'name',
              label: 'marketing_name',
              filter: true,
              sort: true
            },
            {
              name: 'code',
              label: 'code',
              filter: true,
              sort: true
            }
          ],
          selected: null,
          startAt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
          endAt: this.$moment().format('YYYY-MM-DD'),
          date: [],
          active: 1,
          category: '',
          name: '',
          code: ''
        },
        reasonOptions: {},
        enableSave: false
      }
    },
    mixins: [
      validationMixin
    ],
    watch: {
      'filter.key': function () {
        this.debouncedInput()
      },
      'dataTable.currentPage': function (val) {
        this.refreshData()
      },
      'dataTable.perPage': function (val) {
        this.refreshData()
      },
      'filter.active': function (val) {
        this.refreshData()
      },
      'filter.category': function (val) {
        this.refreshData()
      }
    },
    created () {
      this.$Progress.start()
      this.getStatusData()
      this.getListCategories()
    },
    mounted () {
      if (this.$route.params.uuid) {
        this.getDataReason()
        this.getStoreInfo(this.$route.params.uuid) 
      }
    },
    methods: {
      checkPermission(userInfo, permission) {
        let modules = userInfo.modules ? userInfo.modules : {}
        let adminIds = [1, 34, 35, 62]
        return adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1;
      },
      getStatusData () {
        for (let l in this.languages) {
          const language = this.languages
          this.options[language] = [
            { text: this.$t('store.menu', language), value: 'menu' },
            { text: this.$t('store.combo', language), value: 'combo' }
          ]
        }
      },
      getListCategories () {
        const vm = this
        vm.axios.menu.getListCategories(function (response) {
          vm.categories = []
          for (let l in vm.languages) {
            const language = vm.languages
            vm.status[language] = [
              { text: vm.$t('common.all', language), value: '' },
              { text: vm.$t('common.active', language), value: '1' },
              { text: vm.$t('common.inactive', language), value: '0' }
            ]
            vm.categories[language] = [{
              text: vm.$t('common.all', language),
              value: ''
            }]
            for (let c in response.data.data.items) {
              vm.categories[language].push({
                text: response.data.data.items[c]['name'][language] != null ? response.data.data.items[c]['name'][language] : '',
                value: response.data.data.items[c]['id']
              })
            }
          }
        })
      },
      getStoreInfo (uuid) {
        const vm = this
        vm.axios.outlet.getOutletDetail(uuid, response => {
          if (response.status === 200) {
            let data = response.data.data.item
            vm.outletCode = data.code
            vm.refreshData()
          }
        }, error => {
          console.log('error', error)
        })
      },
      getDataReason () {
        const vm = this
        vm.axios.menu.getListReasonStatus(`page=1&limit=500&sort_field=id&sort_type=asc`, response => {
          if (response.status === 200) {
            const data = vm.getValueFromAttr(response, 'data.data.items', [])
            for (let i = 0; i < vm.languages.length; i++) {
              const language = vm.languages[i];
              vm.reasonOptions[language] = [];
              data.forEach(item => {
                vm.reasonOptions[language].push({
                  value: vm.getValueFromAttr(item, `uuid`, null),
                  text: vm.getValueFromAttr(item, `name.${language}`, null),
                  disabled: !vm.getValueFromAttr(item, `active`, false)
                })
              });
            }
          }
        }, error => {
          console.log('error', error)
        })
      },
      changeMode () {
        this.filter.category = ''
        this.dataTable.currentPage = 1
        this.refreshData()
      },
      refreshData () {
        const vm = this
        const params = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: (this.dataTable.sort.field == 'code') ? 'sku' : this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type
        }
        if (this.filter.category != '') {
          params['category_id'] = this.filter.category
        }
        if (this.filter.active != '') {
          params['active'] = this.filter.active
        }
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          if (this.field == 'code') {
            this.field = 'sku'
          }
          params[this.field] = this.key.trim()
        }
        if (this.mode === 'menu') {
          vm.axios.menu.listMenuOutOfStock(this.outletCode, params, function (response) {
            vm.enableSave = false
            const data = response.data.data.items
            data.forEach(element => {
              const outOfStock = element.out_of_stock
              if (outOfStock && outOfStock.uuid) {
                element.value = 1
                element.initialValue = 1
                element.reason_uuid = outOfStock.reason_uuid
                const arrsFirst = vm.getValueFromAttr(element, 'first_layers', [])
                const arrFirstOutOfStock = vm.getValueFromAttr(outOfStock, 'first_layers', [])
                for (let i = 0; i < arrFirstOutOfStock.length; i++) {
                  const first = arrFirstOutOfStock[i];
                  const objFirst = vm.getObjectInArrs(first.id, arrsFirst, 'first_id')
                  if (objFirst) {
                    objFirst.value = 1
                    const arrsSecond = vm.getValueFromAttr(objFirst, 'second_layers', [])
                    const arrSecondOutOfStock = vm.getValueFromAttr(first, 'second_layers', [])
                    for (let j = 0; j < arrSecondOutOfStock.length; j++) {
                      const second = arrSecondOutOfStock[j];
                      const objSecond = vm.getObjectInArrs(second.id, arrsSecond, 'second_id')
                      if (objSecond) {
                        objSecond.value = 1
                      }
                    }
                  }
                }
              }
            });
            vm.dataTable.items = data
            vm.dataTable.total = response.data.data.pagination && response.data.data.pagination.total || data.length
          })
        } else {
          vm.axios.menu.listComboOutOfStock(this.outletCode, params, function (response) {
            vm.enableSave = false
            const data = response.data.data.items
            data.forEach(element => {
              const outOfStock = element.out_of_stock
              if (outOfStock && outOfStock.uuid) {
                element.value = 1
                element.initialValue = 1
                element.reason_uuid = outOfStock.reason_uuid
              }
            });
            vm.dataTable.items = data
            vm.dataTable.total = response.data.data.pagination && response.data.data.pagination.total || data.length
          })
        }
      },
      chooseMenu (value, item, first, second) {
        this.enableSave = true
        const valueData = !value ? 1 : 0
        if (valueData === 1) {
          if (item) {
            item.value = valueData
          }
          if (first) {
            first.value = valueData
          }
          if (second) {
            second.value = valueData
          }
        } else {
          if (second) {
            second.value = valueData
          } else if (first) {
            first.value = valueData
            const arrsSecond = this.getValueFromAttr(first, 'second_layers', [])
            for (let i = 0; i < arrsSecond.length; i++) {
              const second = arrsSecond[i];
              second.value = valueData
            }
          } else {
            item.value = valueData
            const arrsFirst = this.getValueFromAttr(item, 'first_layers', [])
            for (let i = 0; i < arrsFirst.length; i++) {
              const first = arrsFirst[i];
              first.value = valueData
              const arrsSecond = this.getValueFromAttr(first, 'second_layers', [])
              for (let j = 0; j < arrsSecond.length; j++) {
                const second = arrsSecond[j];
                second.value = valueData
              }
            }
          }
        }
        this.$forceUpdate()
      },
      getParamsOutOfStock (type) {
        if (type === 'combo') {
          const params = {
            combos: []
          }
          this.dataTable.items.forEach(element => {
            if (Number(element.initialValue) === 1 || Number(element.value) === 1) {
              const obj = {
                id: element.id,
                uuid: element.uuid,
                sku: element.sku,
                value: Number(element.value),
                reason_uuid: Number(element.value) === 1 ? element.reason_uuid : ''
              }
              params.combos.push(obj)
            }
          })
          return params
        }
        const params = {
          menus: []
        }
        this.dataTable.items.forEach(element => {
          if (Number(element.initialValue) === 1 || Number(element.value) === 1) {
            const obj = {
              id: element.id,
              uuid: element.uuid,
              sku: element.sku,
              value: Number(element.value),
              reason_uuid: Number(element.value) === 1 ? element.reason_uuid : ''
            }
            const arrsFirst = this.getValueFromAttr(element, 'first_layers', [])
            for (let i = 0; i < arrsFirst.length; i++) {
              const first = arrsFirst[i];
              if (Number(first.value) === 1) {
                if (!obj.first_layers) {
                  obj.first_layers = []
                }
                const objFirst = {
                  id: first.first_id,
                  uuid: `first_${first.first_id}`,
                  sku: first.sku
                }
                obj.first_layers.push(objFirst)
                const arrsSecond = this.getValueFromAttr(first, 'second_layers', [])
                for (let j = 0; j < arrsSecond.length; j++) {
                  const second = arrsSecond[j];
                  if (Number(second.value) === 1) {
                    if (!objFirst.second_layers) {
                      objFirst.second_layers = []
                    }
                    objFirst.second_layers.push({
                      id: second.second_id,
                      uuid: `second_${second.second_id}`,
                      sku: second.sku
                    })
                  }
                }
              }
            }
            params.menus.push(obj)
          }
        })
        return params
      },
      pushMenuOutOfStock () {
        const vm = this
        if (vm.checkRequireReason()) {
          vm.$toastr.error(vm.$t('message.validate_reason'), vm.$t('message.error'), {})
          return
        }
        const params = this.getParamsOutOfStock(this.mode)
        if ((this.mode === 'combo' && params.combos.length === 0) || (this.mode === 'menu' && params.menus.length === 0)) {
          vm.$toastr.error(vm.$t('store.msg_save_out_of_stock'), '', {})
          return
        }
        console.log(params)
        if (this.mode === 'menu') {
          vm.axios.menu.pushMenuOutOfStock(this.outletCode, params, function (response) {
            vm.refreshData()
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.update_successful'), {})
          }, function (error) {
            // vm.$toastr.error(vm.$t('message.error'), vm.$t('message.error'), {})
          })
        } else {
          vm.axios.menu.pushComboOutOfStock(this.outletCode, params, function (response) {
            vm.refreshData()
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.update_successful'), {})
          }, function (error) {
            // vm.$toastr.error(vm.$t('message.error'), vm.$t('message.error'), {})
          })
        }
      },
      isShowReason () {
        return this.outletConfig.config && this.outletConfig.config.show_reason || false
      },
      checkRequireReason () {
        for (let i = 0; i < this.dataTable.items.length; i++) {
          const element = this.dataTable.items[i];
          if (Number(element.value) === 1 && !element.reason_uuid) {
            return true
          }
        }
        return false
      }
    }
  }
</script>

<style scoped>
  .menu-group-form .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-group-form .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-group-form .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }

  table tr th:last-child {
    width: 696px;
  }

  .menu-group-form .btn-save {
    float: right;
    margin-right: 22px;
  }

  .menu-group-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .preview-image {
    width: 100%;
  }

  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }

  .points i {
    position: absolute;
  }

  .step-commit {
    margin-left: calc(0% - 10px);
  }

  .step-updated {
    margin-left: calc(33% - 15px);
  }

  .step-publishing {
    margin-left: calc(66% - 15px);
  }

  .step-publish {
    margin-left: calc(100% - 20px);
  }

  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .current-point {
    font-size: 30px;
  }

  .img-min-height {
    min-height: 161px;
  }

  .custom-checkbox {
    padding-left: 1.5rem;
  }

  .min-width-200 {
    min-width: 200px;
  }

  .menu-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .menu-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .rectangle-9-copy {
    width: auto;
    border: 1px solid #E1E6EB;
    border-radius: 3px;
    background-color: #F5F7F9;
  }

  .rectangle-9-copy-header {
    width: auto;
    border-radius: 3px 3px 0 0;
    background-color: #E1E6EB;
  }

  .thead-th {
    padding: 0.4rem !important;
  }

  .table-thead {
    background-color: #c3cbd4;
  }

  #menu_out_of_stock_btn {
    height: 39px;
    width: 149px;
  }

  .first-layers:is(:last-child) {
    margin-bottom: 0 !important;
  }

  .col-200w {
    width: 200px !important;
  }

  .combobox-require select {
    border-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/OutletMenuOutOfStock.vue